const citiesDB = [
  {city: "Seoul", cntry: "Korea"},
  {city: "LA", cntry: "US"},
  {city: "NY", cntry: "US"},
  {city: "London", cntry: "UK"}
]

export default citiesDB